/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum QuickAccessIssueHistoryVisibility {
    Recent = '0',
    Hide = 1,
}
